import styled from 'styled-components'
import Typography from '@mui/material/Typography'

export const WhiteTextTypography = styled(Typography)`
  color: white;
  text-align: center;
`

export const WhiteTextTypographyLeft = styled(Typography)`
  color: white;
  text-align: left;
`

export const HighlightedTypography = styled(Typography)`
  font-weight: bold;
`
